import React from 'react';
import { useTranslation } from 'react-i18next';
import { GrievanceItem } from '../../services/types/Grievance';
import GeneralInfoItem from '../Operations/Operation/GeneralInfoItem';

interface Props {
  grievance: GrievanceItem;
}
const GIGrievanceInfo: React.FC<Props> = ({ grievance }) => {
  const { t } = useTranslation();

  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('mainTopic')}>{grievance.mainTopicName}</GeneralInfoItem>
      <GeneralInfoItem title={t('subTopic')}>{grievance.subTopicName}</GeneralInfoItem>
      <GeneralInfoItem title={t('secondarySubTopic')}>
        {grievance.secondarySubTopicName}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('prioritization')}>{grievance.prioritization}</GeneralInfoItem>

      <GeneralInfoItem title={t('grievanceTimeElapsed')}>
        {grievance.grievanceTimeElapsed}
      </GeneralInfoItem>
    </div>
  );
};

export default GIGrievanceInfo;
